export function parseSocketResponse(response: unknown, args: unknown[]): unknown {
	const rawResponse = args.length === 0 ? response : [response, ...args];
	return typeof rawResponse === "string" ? JSON.parse(rawResponse) : rawResponse;
}

export function parseNonEmptyString(value: unknown): string {
	return typeof value === "string" ? value.trim() : "";
}
